<template>
  <div>
    <template v-for="(item, $i) in actionItems">
      <v-dialog :key="$i" v-model="item.show" width="900" persistent>
        <component
          v-if="item.show"
          :event="event"
          :is="item.component"
          @close="item.show = false"
        />
      </v-dialog>
    </template>
    <v-menu left>
      <template #activator="{ attrs, on }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <template v-for="(item, $i) in actionItems">
          <v-list-item :key="$i" @click="item.show = true">
            <v-list-item-icon>
              <v-icon small v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import EventEditModal from './EventEditModal'
import EventArchiveModal from './EventArchiveModal'

export default {
  name: 'EventMoreActionsButton',

  props: {
    event: Object
  },

  data: () => ({
    actionItems: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: EventEditModal,
        show: false
      },
      {
        title: 'Arkivera',
        icon: 'mdi-archive-arrow-down',
        component: EventArchiveModal,
        show: false
      }
    ]
  })
}
</script>
